import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

export const initiateSentry =()=>{
    // Sentry is the crash analiytcs tool
    Sentry.init({
      dsn: 'https://6104c102220b4035aa7995bc63bae367@sentry.io/1444395',
      integrations: [
        new Integrations.Vue({
          Vue,
          attachProps: true,
        }),
      ],
    });
    console.log("Connected sentry")
}

export const captureMessage=(message)=>{
  Sentry.captureMessage(message);
}

export const captureEvent=(message, error)=>{
  Sentry.captureEvent({
    message: message,
    stacktrace: error,
  });
}



// WEBPACK FOOTER //
// ./src/third-party/sentry/services/sentryService.js